import i18next from "i18next";
import React from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";

const IconListCell = ({ isOpen, toggle, data, modalTitle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
      <ModalBody>
        <Table>
          <thead>
            <tr>
              <th>{i18next.t('lib')}</th>
              <th>{i18next.t('createdAt')}</th>
              <th>{i18next.t('updatedAt')}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.map((item, index) => (
              <tr key={index}>
                <td>{item.lib}</td>
                <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                <td>{new Date(item.updatedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
};

export default IconListCell;
